
const HotelSliderSkeleton: React.FC = () => {
    return(
        <section>
            <div className="animate-pulse flex justify-between p-4">
            {/* {[...Array(3)].map((_, index) => ( */}
                <div className="mb-6 w-full">
                <div className="relative h-80 w-[22rem] bg-gray-300 rounded-md"></div>
                <div className="pt-2 rounded-b-md w-[22rem] mt-2 items-center">
                    <div className="flex space-x-1">
                    <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
                    <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
                    <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
                    <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
                    <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
                    </div>
                </div>
                <div className="mt-2 w-[22rem] h-4 bg-gray-300 rounded"></div>
                <div className="mt-2 w-48 h-4 bg-gray-300 rounded"></div>
                <div className="mt-2 w-[22rem] flex justify-between items-center">
                    <div className="w-20 h-6 bg-gray-300 rounded"></div>
                    <div className="w-24 h-6 bg-gray-300 rounded"></div>
                </div>
                </div>
            {/* ))} */}
            </div>
        </section>
    );
};

export default HotelSliderSkeleton;